// extracted by mini-css-extract-plugin
export default {"root":"profile-form_root__kKgvd","title":"profile-form_title__uCEOb","button":"profile-form_button__Xk8Uf","submitButton":"profile-form_submitButton__aNDWu"};